import { useCrowdfundingProvider } from '#Context/crowdfunding/Crowdfunding.provider.js';
import { CampaignPeerInfoCard } from '#crowdfunding/components/Cards/CampaignPeerInfoCard.js';
import {
  useListCampaignPeers,
  useShowConsumerCampaignById,
  useShowConsumerCampaignSettingsById,
} from '@givebacks/api/store';
import { useNavigate } from 'react-router-dom';
import { ButtonMantine, Center, Grid, Stack, Title, TransitionElement } from 'ui';

export const Teams = () => {
  const { causeId, campaignId } = useCrowdfundingProvider();
  const { data: campaign } = useShowConsumerCampaignById({ causeId, campaignId });
  const { data: response } = useListCampaignPeers({
    campaignId: campaign?.uuid,
    causeId: campaign?.cause_id,
    peer_type: 'teams',
    queryOptions: {
      options: {
        credits: true,
      },
      order: {
        field: 'rank',
        direction: 'asc',
      },
    },
  });
  const teams = response?.teams;
  const navigate = useNavigate();
  const { data: campaignSettings } = useShowConsumerCampaignSettingsById({
    causeId,
    campaignId,
  });

  if (!campaignSettings?.isTeamsEnabled) return null;

  return (
    <TransitionElement mounted={!!teams?.length} transition={'fade'} duration={50}>
      <Stack maw={{ base: '100%', md: 684 }}>
        <Title order={2} style={{ textTransform: 'capitalize' }}>
          {campaign?.team_options.convention_plural}
        </Title>
        <Grid>
          {teams
            ?.filter((_, index) => index < 3)
            .map((team) => {
              return (
                <Grid.Col
                  span={{ base: 12, md: 4 }}
                  key={team.uuid}
                  onClick={() => navigate(`teams/${team.uuid}`)}
                >
                  <CampaignPeerInfoCard
                    peer_id={team.uuid}
                    type="teams"
                    causeId={campaign?.cause_id}
                    campaignId={campaign?.uuid}
                  />
                </Grid.Col>
              );
            })}
        </Grid>
        {teams?.length && teams?.length > 3 && (
          <Center w="100%">
            <ButtonMantine size="sm" w={122} onClick={() => navigate('teams')}>
              View All
            </ButtonMantine>
          </Center>
        )}
      </Stack>
    </TransitionElement>
  );
};
